import { Group, Icon, SelectionCard } from '@melio/penny';

export interface FactorOption {
  value: string;
  label: string;
  icon: 'phone' | 'email';
}

interface FactorSelectorProps {
  options: FactorOption[];
  selected: string;
  onSelect: (value: string) => void;
}

// Renders nothing when there's only one option - a picker with a single,
// undeletable choice isn't a real choice. Becomes live the moment a second
// factor type exists in `available_factors`.
export const FactorSelector = ({ options, selected, onSelect }: FactorSelectorProps) => {
  if (options.length <= 1) {
    return null;
  }

  return (
    <Group variant="vertical" spacing="s" data-testid="factor-selector">
      {options.map((option) => (
        <SelectionCard
          key={option.value}
          mainLabelProps={{ label: option.label }}
          leftElement={<Icon type={option.icon} />}
          selected={selected === option.value}
          onClick={() => onSelect(option.value)}
          data-testid={`factor-option-${option.value}`}
        />
      ))}
    </Group>
  );
};
